import React from "react";
import "./buttonSelectCategory.css";
import ReactTooltip from "react-tooltip";

const ButtonSelectCategory = ({ options, field, form: { setFieldValue } }) => {
  const value = getValue(options, field);
  const handleChange = (option) => {
    if (!option) {
      return setFieldValue(field.name, null);
    }
    const newValue = Array.isArray(option.value)
      ? option.map((item) => item.value)
      : option.value;

    return setFieldValue(field.name, newValue);
  };
  const getClassName = (option) => {
    const base =
      "d-flex justify-content-around selectable-button-category align-items-center ";
    if (!value.length) {
      return base;
    }

    if (option.value === value[0].value) {
      return base + "active-selectable-button";
    }
    return base;
  };

  return (
    <div className="button-select-category-box">
      <div style={{ fontSize: 14 }}>Category:</div>
      {options.map((option, i) => {
        return (
          <div
            key={`${i}-${option.value}`}
            className={getClassName(option)}
            color="primary"
            data-tip={option.value}
            outline
            onClick={() => handleChange(option)}
          >
            {option.label}
          </div>
        );
      })}
      <ReactTooltip place="top" effect="solid" type="info" />
    </div>
  );
};

function getValue(options, field) {
  if (!options) {
    return "";
  }

  return options.filter((option) =>
    Array.isArray(field.value)
      ? field.value.indexOf(option.value) >= 0
      : field.value === option.value
  );
}

export default ButtonSelectCategory;



// WEBPACK FOOTER //
// ./src/components/formik/upsertWatchlistEntryForm/ButtonSelectCategory.jsx